import { FC, memo } from "react"
import { useTranslation } from "react-i18next"
import { mobNameKey } from "@/helpers/mobName"
import { VitalBars } from "@/ui/VitalBars"
import styles from "./BattleFighterCard.module.scss"
import { IBattleFighterCardProps } from "./types"

const BattleFighterCardComponent: FC<IBattleFighterCardProps> = ({
  fighter
}) => {
  const { t } = useTranslation(["battle", "mobs"])

  return (
    <section className={styles.BattleFighterCard}>
      {fighter.imageUrl ? (
        <img
          className={styles.BattleFighterCard_image}
          src={fighter.imageUrl}
          alt=""
          decoding="async"
        />
      ) : (
        <div className={styles.BattleFighterCard_image} />
      )}
      {fighter.kind === "HERO" ? (
        <span className={styles.BattleFighterCard_name}>
          {fighter.username ?? t("screen.hero", { ns: "battle" })}
        </span>
      ) : (
        <span className={styles.BattleFighterCard_name}>
          {fighter.typeCode
            ? t(mobNameKey(fighter.typeCode), {
                ns: "mobs",
                defaultValue: fighter.typeCode
              })
            : t("screen.mob", { ns: "battle" })}
          {fighter.level !== null && (
            <span className={styles.BattleFighterCard_level}>
              {t("card.level", { ns: "mobs", level: fighter.level })}
            </span>
          )}
        </span>
      )}
      {fighter.classKeys.length > 0 && (
        <span className={styles.BattleFighterCard_classes}>
          {fighter.classKeys.map((key) => t(key, { ns: "battle" })).join(" · ")}
        </span>
      )}
      <VitalBars vitals={fighter.vitals} />
    </section>
  )
}

export const BattleFighterCard = memo(BattleFighterCardComponent)
